import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { AvatarModule } from 'ngx-avatar';
import { AppRoutes } from './app.routing';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { WelcomeLayoutComponent } from './layouts/welcome/welcome-layout.component';
import { DashLayoutComponent } from './layouts/dash/dash-layout.component';
import { ToastrModule } from 'ngx-toastr';
import { AuthGuard } from './auth/auth.guard';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { SharedModule } from './shared/shared.module';
import { BasicAuthInterceptor } from './auth/basic-auth.interceptor';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import localePt from '@angular/common/locales/pt';
import {NgxMaskModule} from 'ngx-mask';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localePt);

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    NgxMaskModule.forRoot(),
    RouterModule.forRoot(AppRoutes),
    ToastrModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '3px',
      primaryColour: '#bf2138',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff'
    })
  ],
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    WelcomeLayoutComponent,
    DashLayoutComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ]
})
export class AppModule {
  ['ngAvatar'];
}

/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
